import { connect } from 'react-redux';
import { Map, List } from 'immutable';
import decorate from '../../../utils/decorate';

import { request as queryCompetitions } from '../../../modules/competitions/actions/query';
import { request as createCompetition } from '../../../modules/competitions/actions/create';
import { request as saveCompetition } from '../../../modules/competitions/actions/save';
import { request as getSports } from '../../../modules/sports/actions/get';
import { request as addTagValue } from '../../../modules/tags/actions/add-value';

const STATE_KEY = 'trading-filters';

import TradingEventsFilters from './TradingEventsFilters.jsx';

function mapStateToProps(state) {
    const competitions = state.competitions.get( 'items', Map() );
    const filteredCompetitions = state.competitions.getIn( [ 'collections', STATE_KEY, 'items' ], List() )
        .map( compId => competitions.get( compId ) );

    return {
        sports: state.sports.get('items'),
        competitions: filteredCompetitions,
        competitionsStatus: state.competitions.getIn( [ 'collections', STATE_KEY, 'state' ], 'FINISHED' ),
        countries: state.tags.getIn([ STATE_KEY, 'items', 'country', 'values' ]),
        state: state.sports.get('state')
    };
}

function mapDispatchToProps(dispatch) {
    const competitionFields = {
        'displayFields': [ 'id', 'name', 'display', 'active', 'sport', 'displayOrder' ]
    };

    return {
        onLoadSportsRequest: () => dispatch(getSports()),
        onLoadCompetitionsRequest: ( query ) => dispatch( queryCompetitions( STATE_KEY, {
            ...competitionFields,
            perPage: 100,
            ...query
        } ) ),
        onAddTagValueRequest: (tag, data) => dispatch(addTagValue(tag, data)),
        onCreateCompetitionRequest: (data) => dispatch(createCompetition(data)),
        onUpdateCompetitionRequest: (id, data) => dispatch(saveCompetition(id, data))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    TradingEventsFilters
);
